<template>
  <div>
    <div class="serchBox">
      <!-- <div class="logoImg img">
        <img src="../../assets/img/logo-p.png" alt="" srcset="" />
      </div> -->
      <div class="inpBox">
        <div class="inp">
          <div class="search">
            <div class="iconfont icon-search"></div>
          </div>
          <div class="shu"></div>
          <input
            type="text"
            v-model="searChTxt"
            @keyup.enter="searchClick"
            placeholder="请输入招聘会名称搜索"
            name=""
            id=""
          />
          <div class="searchBtn" @click="searchClick">搜索</div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="leftBox">
        <div class="lbBox">
          <a-carousel autoplay>
            <div class="imgs img">
              <img
                :src="'https://www.yhrl.com/static/resource/2024-09-21/5b6u5L+h5Zu+54mHXzIwMjQwOTIxMTA1NTU2MTcyNjg4NzM3MjUxMzYyNzEwMA.png'"
                alt=""
                srcset=""
              />
            </div>
          </a-carousel>
        </div>
        <!-- <div class="cont">
          <div class="bjImg img">
            <img
              :src="one.resources ? $imgUrl + one.resources[0].path_name : ''"
              alt=""
            />
          </div>
          <div class="box">
            <div class="zt">
              最新招聘会 <span>联系:{{ one.mobile }}</span>
            </div>
            <div class="title c-1">{{ one.name }}</div>
            <div class="text c-3">
              {{ one.content ? one.content : "暂无招聘介绍" }}
            </div>
            <div class="txtHead">
              <div class="shu"></div>
              <div class="name">举办地点</div>
            </div>
            <div class="txt">{{ one.address }}</div>
            <div class="txtHead">
              <div class="shu"></div>
              <div class="name">举办时间</div>
            </div>
            <div class="txt">{{ one.start_time }} - {{ one.end_time }}</div>
            <div class="btnBox" @click="jump(one.id)">查看详情</div>
          </div>
        </div> -->
        <div class="li" @click="jump(item.id)" v-for="item in list">
          <div class="img img">
            <img
              :src="item.resources ? $imgUrl + item.resources[0].path_name : ''"
              alt=""
            />
          </div>
          <div class="box">
            <div class="name c-1">{{ item.name }}</div>
            <div class="text">举办时间：{{ item.start_time }}</div>
            <div class="text c-1">举办地点：{{ item.address }}</div>
            <div class="text">联系电话：{{ item.mobile }}</div>
          </div>
          <div class="btns">
            <!-- <div class="text">立即参与</div> -->
            <div class="text">查看详情</div>
          </div>
          <div class="ztImg">
            <img
              v-if="!item.time"
              src="../../assets/img/js.png"
              alt=""
              srcset=""
            />
            <img v-else src="../../assets/img/yd.png" alt="" srcset="" />
          </div>
        </div>
        <div class="fenye" v-if="totalCount > 10">
          <a-pagination
            :default-current="page.pageNo"
            v-model="page.pageNo"
            :total="totalCount"
            :page-size="10"
            @change="pageOnChange"
          />
        </div>
      </div>
      <div class="rightCont">
        <LoginZj />
        <div class="cont" v-for="item in tjList">
          <div class="img">
            <img
              :src="item.resources ? $imgUrl + item.resources[0].path_name : ''"
              alt=""
            />
          </div>
          <div class="text">{{ item.name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoginZj from "../component/loginZj.vue";

export default {
  components: {
    LoginZj,
  },
  name: "",
  data() {
    return {
      typeOn: 0,
      typeList: ["找工作", "找师傅"],
      judge: true,
      page: {
        pageNo: 1,
        pageSize: 30,
      },
      list: [],
      totalCount: 0,
      one: {},
      tjList: [],
      searChTxt: "",
    };
  },
  created() {
    this.listGet();
    this.tjGet();
  },
  methods: {
    searchClick() {
      this.page.name = this.searChTxt;
      this.page.pageNo = 1;
      this.totalCount = 0;
      this.listGet();
    },
    pageOnChange(i) {
      this.list = [];
      this.page.pageNo = i;
      this.listGet();
    },
    tjGet() {
      this.$get("/nozzle/web/recruit_gets", this.page).then((res) => {
        console.log(res);
        if (res.data) {
          for (let i = 0; i < res.data.length; i++) {
            const e = res.data[i];
            this.tjList.push(e);
          }
        }
      });
    },
    listGet() {
      if (!this.judge) {
        return;
      }
      this.judge = false;
      this.$get("/nozzle/web/recruit_gets", this.page).then((res) => {
        console.log(res.data);

        this.judge = true;
        if (this.totalCount == 0) {
          this.totalCount = res.totalCount;
        }
        // this.one = res.data[0];
        // this.one.content = this.one.content
        //   .replace(/<[^<>]+>/g, "")
        //   .replace(/&nbsp;/gi, "")
        //   .replace(/\s/g, "");
        if (res.data) {
          for (let i = 0; i < res.data.length; i++) {
            const e = res.data[i];
            let date1 = this.$moment().format("YYYY-MM-DD");
            let date2 = this.$moment(e.start_time).format("YYYY-MM-DD");
            let time = this.$moment(date1).isBefore(date2);
            e.time = time;
            e.start_time = e.start_time.split(" ")[0];
            e.end_time = e.end_time.split(" ")[0];
            e.content = e.content
              .replace(/<[^<>]+>/g, "")
              .replace(/&nbsp;/gi, "")
              .replace(/\s/g, "");
          }
          this.list = res.data;
        } else {
          this.list = [];
        }
      });
    },
    jump(id) {
      // this.$router.push({
      //   path: "/zhpCont",
      //   query: {
      //     id,
      //   },
      // });
      window.open("#/zhpCont?id=" + id);
    },
    typeClick(i) {
      this.typeOn = i;
    },
  },
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
.serchBox {
    display: flex;
    justify-content: center;
    padding: 25px 55px;
    padding-right: 70px;
    padding-bottom: 5px;
    align-items: center;
    width: 1280px;
    margin: auto;
    box-sizing: border-box;
    margin-bottom: 20px;
    .logoImg {
      width: 150px;
    }

    .inpBox {
      width: calc(100% - 70px);
      box-sizing: border-box;

      .inp {
        border: 2px solid #1a78ec;
        background-color: #fff;
        width: 100%;
        height: 50px;
        border-radius: 10px;
        display: flex;
        overflow: hidden;
        align-items: center;
        position: relative;

        .search {
          width: 65px;
          display: flex;
          align-items: center;
          justify-content: center;
          height: 100%;

          .iconfont {
            font-size: 24px;
            color: #999;
          }
        }

        .shu {
          width: 2px;
          height: 20px;
          background-color: #c9c9c9;
        }

        input {
          width: calc(100% - 67px);
          height: 100%;
          padding-left: 20px;
          box-sizing: border-box;
        }

        .searchBtn {
          cursor: pointer;
          width: 90px;
          height: calc(100% - 4px);
          position: absolute;
          right: 2px;
          top: 2px;
          background-color: #1a78ec;
          color: #fff;
          font-weight: 600;
          font-size: 16px;
          border-radius: 5px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }
.content {
  width: 1280px;
  margin: auto;
  display: flex;
  .leftBox {
    width: calc(100% - 380px);
    .lbBox {
      border-radius: 10px;
      overflow: hidden;
      .imgs {
        height: 300px;
      }
    }
    .cont {
      border-radius: 10px;
      overflow: hidden;
      height: 450px;
      position: relative;
      .bjImg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .box {
        background-color: #1677ff;
        color: #fff;
        border-top-right-radius: 50px;
        z-index: 9;
        position: absolute;
        top: 0;
        left: 0;
        width: 50%;
        height: 100%;
        box-sizing: border-box;
        padding: 30px;
        .zt {
          font-size: 16px;
          margin-bottom: 5px;
          span {
            font-size: 14px;
            margin-left: 15px;
            opacity: 0.8;
          }
        }
        .title {
          font-weight: 600;
          font-size: 32px;
          margin-bottom: 15px;
        }
        .text {
          opacity: 0.8;
          text-align: justify;
          line-height: 150%;
          margin-bottom: 30px;
        }
        .txtHead {
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          .shu {
            background-color: #20ceec;
            height: 16px;
            margin-right: 5px;
            border-radius: 4px;
            width: 4px;
          }
          .name {
            font-weight: 500;
            font-size: 15px;
          }
        }
        .txt {
          margin-bottom: 15px;
        }
        .btnBox {
          position: absolute;
          bottom: 40px;
          left: 30px;
          width: 130px;
          font-weight: 600;
          height: 45px;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #fff;
          color: #1677ff;
          border-radius: 5px;
          cursor: pointer;
        }
        .btnBox1 {
          position: absolute;
          bottom: 40px;
          left: 180px;
          width: 130px;
          font-weight: 600;
          height: 45px;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #ee691c;
          color: #fff;
          cursor: pointer;
          border-radius: 5px;
        }
      }
    }
    .li {
      display: flex;
      border-radius: 10px;
      background-color: #fff;
      margin-top: 15px;
      overflow: hidden;
      position: relative;
      .img {
        width: 240px;
        height: 160px;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .box {
        width: calc(100% - 400px);
        box-sizing: border-box;
        padding: 15px;
        padding-left: 20px;
        .name {
          font-size: 20px;
          font-weight: 600;
          margin-bottom: 10px;
        }
        .text {
          color: #666;
          margin-bottom: 10px;
        }
      }
      .btns {
        width: 160px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        padding-right: 15px;
        box-sizing: border-box;
        .text {
          background-color: #ee691c;
          color: #fff;
          width: 90px;
          margin-bottom: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          height: 40px;
          border-radius: 5px;
          z-index: 9;
          position: relative;
          cursor: pointer;
        }
        .text:last-child {
          margin-bottom: 0;
          background-color: #1677ff;
        }
      }
      .ztImg {
        position: absolute;
        top: 0;
        right: 0;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .rightCont {
    width: 380px;
    padding-left: 15px;
    .cont {
      background-color: #fff;
      border-radius: 10px;
      margin-bottom: 10px;
      overflow: hidden;
      .img {
        width: 100%;
        height: 180px;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .text {
        padding: 15px;
        font-weight: 600;
        font-size: 16px;
      }
    }
  }
}
</style>
